import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Team from "./pages/Team";
import Calculators from "./pages/Calculators";
import Contact from "./pages/Contact";
import { Toaster } from "./components/ui/sonner";
// Import the Modal Component
import StartupRegistrationModal from "./components/StartupRegistrationModal";

function App() {
  // 1. State to manage if the modal is open or closed
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 2. Automatically trigger the modal 5 seconds after the app loads
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 5000); // 5000 milliseconds = 5 seconds

    // Cleanup the timer to prevent memory leaks
    return () => clearTimeout(timer);
  }, []); // Empty dependency array ensures this only runs once when the app starts

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/team" element={<Team />} />
          <Route path="/calculators" element={<Calculators />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <ChatWidget />
        <Toaster />

        {/* 3. The Modal Component - Placed outside of Routes so it overlays everything */}
        <StartupRegistrationModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
